import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Modal from '../../../components/modal/modal';
import '../../../components/modal/modal.scss';
import './resource-cost-propagation-dialog.scss';

/**
 * Confirmation dialog to select propagation targets when updating a Resource cost.
 *
 * @param {Object} props - Component properties.
 * @param {boolean} props.open - Modal visibility flag.
 * @param {Function} props.onClose - Cancel callback.
 * @param {Function} props.onConfirm - Confirm callback receiving selected options.
 * @returns {JSX.Element} Rendered confirmation dialog component.
 */
export default function ResourceCostPropagationDialog({
  open,
  onClose,
  onConfirm
}) {
  const [options, setOptions] = useState({
    useItemTemplates: true,
    useTaskTemplates: true
  });

  useEffect(() => {
    if (open) {
      setOptions({
        useItemTemplates: true,
        useTaskTemplates: true
      });
    }
  }, [open]);

  const handleOptionChange = (option, checked) => {
    setOptions((prev) => ({ ...prev, [option]: checked }));
  };

  const handleProceed = () => {
    onConfirm(options);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      className="resource-propagation-dialog"
      modalHeading="Resource Cost Update Options"
      modalSaveTxt="PROCEED"
      modalCloseTxt="CANCEL"
      onClick={handleProceed}
      modalCloseBtn={onClose}
      showActionBtn
      primary
      savebtnClass="createBtn"
      cxlbtnClass="cancelBtn"
      dataCy="resource-cost-propagation-modal"
    >
      <div className="resource-propagation-content mb-3">
        <h6 className="options-group-title mb-3">
          Which of the following do you want the changes to be applied to? Select all that apply:
        </h6>

        <div className="options-container ms-2">
          <Form.Check
            type="checkbox"
            id="propagate-item-templates"
            label="Item Templates"
            checked={options.useItemTemplates}
            onChange={(e) => handleOptionChange('useItemTemplates', e.target.checked)}
            className="mb-2"
          />

          <Form.Check
            type="checkbox"
            id="propagate-task-templates"
            label="Task Templates"
            checked={options.useTaskTemplates}
            onChange={(e) => handleOptionChange('useTaskTemplates', e.target.checked)}
            className="mb-2"
          />
        </div>
      </div>
    </Modal>
  );
}
